import React, { useCallback, useEffect, useState } from "react";
import {
    Card,
    Form,
    InputGroup,
    Button,
    Modal
} from "react-bootstrap";
import {
    DataGrid,
    Column,
    Pager,
    Paging,
    Summary,
    TotalItem,
    Selection,
    Scrolling,
    SearchPanel
} from "devextreme-react/data-grid";
import notistack from "modules/core/notistack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faFilePdf, faRetweet } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { BiSolidRightArrowAlt } from "react-icons/bi";
import { GenerateInterStoreInvoice, getInterStoreInventoryProduct, GetInterStoreOderList, ReassignProductToOrder, UpdateInterStoreOrderStatus } from "../services/interStore-transfer.service";
import ProductDetails from "./ProductDetails";
import CustomStore from "devextreme/data/custom_store";
import { HttpStatus } from "modules/core";



const InterStoreTransferDataList: React.FC = (id) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any[]>([]);
    const [searchText, setSearchText] = useState("");
    const [selectedKeys, setSelectedKeys] = useState<number[]>([]);
    const [selectedRow, setSelectedRow] = useState<any | null>(null);
    const navigate = useNavigate();
    const [searchData, setSearchData] = useState<any>()
    const [showModal, setShowModal] = useState(false)
    const [pdfData, setPdfData] = useState<string | null>(null);
    const [showInvoiceModal, setshowInvoiceModal] = useState(false);



    const handleSearch = async () => {
        // if (!searchText.trim()) return;
        if (searchText.trim() === "") {
            notistack.warning("Enter Invoice No to Search");
            return;
        }
        try {
            setShowModal(true)
            setSearchData(searchText.trim())
            // const response = await getInterStoreInventoryProduct(searchText);
            // if(response.status == 200) {

            // setData(response.data || []);
            return
            // }
            // else {
            //     notistack.notifyFromApi(response)
            //     return
            // }

        } catch (error) {
            console.error("Search failed:", error);
            setData([]);
        }
    };

    const dataSource = new CustomStore({
        key: "id",
        load: async (loadOptions) => {
            try {
                const { searchValue, skip, take } = loadOptions;
                const parameterList = new URLSearchParams();
                if (typeof skip === 'number') parameterList.append('skip', skip.toString());
                if (typeof take === 'number') parameterList.append('take', take.toString());
                const search = JSON.parse(JSON.stringify(loadOptions));
                for (const [key, value] of Object.entries(search)) {
                    parameterList.append(key, JSON.stringify(value));
                }
                if (searchValue) {
                    parameterList.append("search", searchValue);
                }
                const response = await GetInterStoreOderList(parameterList);
                return response;
            } catch (error) {
                console.error("Data loading error:", error);
                return { data: [], totalCount: 0 };
            }
        },
    });

    const handleReassign = async (id: any) => {
        try {
            const response = await ReassignProductToOrder(id);

            if (response.status === 200) {
                notistack.success("Product reassigned successfully!");
                reloadDataSource();
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (error) {
            console.error("Reassign failed:", error);
            notistack.error("Failed to reassign product.");
        }
    };


    const [refreshKey, setRefreshKey] = useState(0);

    const reloadDataSource = () => {
        setRefreshKey(prev => prev + 1);
    };
    const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
    const handleSaveSelectedProducts = (rows: any[]) => {
        setSelectedProducts(rows);
        setShowModal(false);
        console.log("Selected Products:", rows);
    };

    const handleViewPdf = async (rowId: any) => {
        setLoading(true);
        try {
            const response = await GenerateInterStoreInvoice(rowId);
            console.log(response)
            if (response.status === HttpStatus.Success) {
                console.log(response)
                setPdfData(response.data.data);
                setshowInvoiceModal(true);
            }
        } catch (error) {
            console.error("Failed to load PDF", error);
        } finally {
            setLoading(false);
        }
    };

    const handelResive = async (id: number) => {
        try {
            const response = await UpdateInterStoreOrderStatus({
                id,
                status: "Received"
            });

            if (response.status === 200) {
                notistack.notifyFromApi(response);
                reloadDataSource();
            }
        } catch (error) {
            console.error("PickUp Failed:", error);
            notistack.error("Failed to pickup product");
        }
    };

    const formatDateToIST = (utcDateString: string): string => {
        if (!utcDateString) return "";
        // Ensure it's parsed as UTC
        const date = new Date(utcDateString + "Z");
        return new Intl.DateTimeFormat("en-IN", {
            timeZone: "Asia/Kolkata", // Force IST
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true, // 12h format with AM/PM
        })
            .format(date)
            .replace(",", ""); // remove comma for clean look
    };
    return (
        <div className="page-content">
            <div className="container-fluid">
                <Card>
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <h5 className="m-0">Inter Store Inventory</h5>
                        <div className="d-flex align-items-center gap-2">


                        </div>
                    </Card.Header>

                    <Card.Body>
                        <DataGrid
                            dataSource={dataSource}
                            showRowLines={true}
                            keyExpr="id"
                            showBorders={true}
                            remoteOperations={{ groupPaging: true }}
                            columnAutoWidth={true}
                            onContentReady={(e) => {
                                const hasData = e.component.totalCount() > 0;
                                e.component.option("pager.visible", hasData);
                                e.component.option("paging.visible", hasData);
                            }}
                            onCellPrepared={(e) => {
                                if (['data', 'header'].includes(e.rowType)) {
                                    e.cellElement.style.textAlign = 'center';
                                }
                            }}
                        >
                            <Scrolling
                                mode='standard'
                                useNative={true}
                                scrollByContent={true}
                                scrollByThumb={true}
                            />
                            <Paging defaultPageSize={10} />
                            <Pager
                                allowedPageSizes={[10, 25, 50, 100]}
                                showPageSizeSelector
                                showNavigationButtons
                                displayMode="full"
                                showInfo
                            />
                            <Summary>
                                <TotalItem />
                            </Summary>
                            <SearchPanel visible width={240} placeholder="Search..." />
                            {/* <Column
                                caption="Action"
                                cssClass="text-center"
                                cellRender={(cellData: { data: any }) => {
                                    const { data } = cellData;

                                    if (data.status === "OnWaiting") {
                                        return (
                                            <div className="d-flex justify-content-center align-items-center gap-2">
                                                <Button
                                                    variant="warning"
                                                    title="Reassign"
                                                    size="sm"
                                                    onClick={() => handleReassign(data.id)}
                                                >
                                                    <FontAwesomeIcon icon={faRetweet} />
                                                </Button>
                                            </div>
                                        );
                                    }

                                    if (data.status === "Requested" || data.status === "Received" || data.status === "Picked Up") {
                                        return (
                                            <div className="d-flex justify-content-center align-items-center gap-2">
                                                <button
                                                    className="btn btn-sm action-btn"
                                                    title="Delivery Challan"
                                                    onClick={() => handleViewPdf(data.id)}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faFilePdf}
                                                        className="ml-2 text-danger"
                                                    />
                                                </button>
                                            </div>
                                        );
                                    }

                                    if (data.status === "Picked Up") {
                                        return(
                                           <div className="d-flex justify-content-center align-items-center gap-2">
                                                <button
                                                    className="btn add-btn btn-sm"
                                                    title="Received"
                                                    onClick={() => handelResive(data.id)}
                                                >
                                                    Received
                                                </button>
                                            </div> 
                                        )
                                    }

                                    return null;
                                }}
                                allowSorting={false}
                                allowFiltering={false}
                            /> */}

                            <Column
                                caption="Action"
                                cssClass="text-center"
                                cellRender={(cellData: { data: any }) => {
                                    const { data } = cellData;
                                    if (data.status === "OnWaiting") {
                                        return (
                                            <div className="d-flex justify-content-center align-items-center gap-2">
                                                <Button
                                                    variant="warning"
                                                    title="Reassign"
                                                    size="sm"
                                                    onClick={() => handleReassign(data.id)}
                                                >
                                                    <FontAwesomeIcon icon={faRetweet} />
                                                </Button>
                                            </div>
                                        );
                                    }
                                    if (data.status === "Requested" || data.status === "Received" || data.status === "Picked Up") {
                                        return (
                                            <div className="d-flex justify-content-center align-items-center gap-2">
                                                <button
                                                    className="btn btn-sm action-btn"
                                                    title="Invoice"
                                                    onClick={() => handleViewPdf(data.id)}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faFilePdf}
                                                        className="ml-2 text-danger"
                                                    />
                                                </button>
                                                {data.status === "Picked Up" && (
                                                    <button
                                                        className="btn add-btn btn-sm"
                                                        title="Received"
                                                        onClick={() => handelResive(data.id)}
                                                    >
                                                        Received
                                                    </button>
                                                )}
                                            </div>
                                        );
                                    }
                                    return null;
                                }}
                                allowSorting={false}
                                allowFiltering={false}
                            />
                            <Column dataField="id" caption="id" visible={false} allowFiltering={false} />
                            <Column dataField="receiptNo" caption="Receipt No." />
                            <Column dataField="salesPerson" caption="Sales Person" />
                            <Column dataField="customer" caption="Customer" />
                            <Column dataField="createdOn" caption="Order Date" dataType="string"
                                calculateCellValue={(rowData) => formatDateToIST(rowData.createdOn)}

                            />
                            <Column dataField="totalAmount" format="#,##0.00" caption="Total Amount" />
                            <Column dataField="paidAmount" format="#,##0.00" caption="Paid Amount" />
                            <Column dataField="gstAmount" format="#,##0.00" caption="Gst Amount" />
                            <Column dataField="status" caption="Status" />
                            {/* <Column dataField="bagNo." caption="Bag No." /> */}
                            <Column dataField="karat" caption="Karat" />
                            <Column dataField="styleNo" caption="Style No." />
                            <Column dataField="size" caption="Size" />
                        </DataGrid>
                    </Card.Body>


                    <Modal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        className="fade"
                        size="lg"
                        dialogClassName="modal-dialog-centered"
                        backdrop="static"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Product Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <ProductDetails onSave={handleSaveSelectedProducts} data={data} closeModal={() => setShowModal(false)} reloadDataSource={reloadDataSource} />
                        </Modal.Body>
                    </Modal>
                </Card>
            </div>
            <Modal size='lg' show={showInvoiceModal} onHide={() => setshowInvoiceModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Purchase Order Voucher</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pdfData ? (
                        <iframe
                            src={`data:application/pdf;base64,${pdfData}`}
                            title="Voucher PDF"
                            width="100%"
                            height="500px"
                            style={{ border: 'none' }}
                        />
                    ) : (
                        <p>No PDF available.</p>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default InterStoreTransferDataList;
